import React, { useState, useEffect } from 'react';
import './About.css';

function About() {
  const [companyInfo, setCompanyInfo] = useState(null);

  useEffect(() => {
    fetch('/api/company-info')
      .then(res => res.json())
      .then(data => setCompanyInfo(data))
      .catch(err => console.error('Error fetching company info:', err));
  }, []);

  return (
    <div className="about-page">
      <div className="page-header">
        <h1>About OneYard Systems</h1>
        <h3>Your Listening Partner</h3>
      </div>

      <section className="about-content">
        <div className="container">
          <div className="about-intro">
            <div className="intro-text">
              <h2>Who We Are</h2>
              <p>
                OneYard Systems is a leading technology services provider dedicated to delivering
                cutting-edge solutions for businesses of all sizes. With over a decade of experience,
                we have become the trusted partner for countless organizations seeking reliable,
                innovative, and cost-effective technology solutions.
              </p>
              <p>
                Our team of expert professionals is committed to understanding your unique business
                challenges and providing tailored solutions that drive growth and efficiency.
              </p>
            </div>
            <div className="intro-image">
              <div className="placeholder-image">🏢</div>
            </div>
          </div>
        </div>
      </section>

      {companyInfo && (
        <section className="company-stats">
          <div className="container">
            <h2>Our Impact</h2>
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-number">{companyInfo.years_experience}+</div>
                <div className="stat-label">Years of Experience</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">{companyInfo.clients_served}+</div>
                <div className="stat-label">Clients Served</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">100%</div>
                <div className="stat-label">Customer Satisfaction</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">24/7</div>
                <div className="stat-label">Support Available</div>
              </div>
            </div>
          </div>
        </section>
      )}

      <section className="our-mission">
        <div className="container">
          <h2>Our Mission & Values</h2>
          <div className="mission-grid">
            <div className="mission-card">
              <h3>🎯 Our Mission</h3>
              <p>
                To empower businesses through innovative technology solutions that enhance productivity,
                security, and growth.
              </p>
            </div>
            <div className="mission-card">
              <h3>💡 Innovation</h3>
              <p>
                We stay at the forefront of technology trends to provide you with the latest and most
                effective solutions.
              </p>
            </div>
            <div className="mission-card">
              <h3>🤝 Partnership</h3>
              <p>
                We work closely with our clients to understand their needs and deliver solutions that
                truly make a difference.
              </p>
            </div>
            <div className="mission-card">
              <h3>✅ Quality</h3>
              <p>
                Excellence in every project is our commitment. We maintain the highest standards in
                all our services.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="team-section">
        <div className="container">
          <h2>Our Team</h2>
          <p className="team-intro">
            Our team consists of highly skilled professionals with expertise across various
            technology domains.
          </p>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-avatar">👨‍💼</div>
              <h3>FRED KIBEE MAMONYI</h3>
              <p>Chief Technology Officer</p>
            </div>
            <div className="team-member">
              <div className="member-avatar">👨‍💼</div>
              <h3>YITZACK RABIN</h3>
              <p>Lead Developer</p>
            </div>
            <div className="team-member">
              <div className="member-avatar">👨‍💼</div>
              <h3>KAIKAI SAITOTI</h3>
              <p>Marketing Director</p>
            </div>
            {/* <div className="team-member">
              <div className="member-avatar">👩‍💼</div>
              <h3>Emily White</h3>
              <p>Security Expert</p>
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
